import { TOptions } from "@mercadopago/sdk-react/esm/mercadoPago/initMercadoPago/type";

export function ProcesarNumerosGrandes(numero: number) {
  if (numero > 999) {
    return (numero / 1000).toFixed(0) + "K";
  }
  if (numero > 9999) {
    return (numero / 1000000).toFixed(0) + "M";
  }
  if (numero > 99999) {
    return (numero / 1000000000).toFixed(0) + "B";
  }
  if (numero > 9999999) {
    return (numero / 1000000000000).toFixed(0) + "T";
  }
  return numero.toString();
}

// date inicio, date fin, return HH:mm:ss
export function ProcesarDuracion(dateInicio: Date, dateFin: Date) {
  let diferencia = dateFin.getTime() - dateInicio.getTime();
  let segundos = Math.floor(diferencia / 1000);
  let minutos = Math.floor(segundos / 60);
  let horas = Math.floor(minutos / 60);
  let dias = Math.floor(horas / 24);
  let meses = Math.floor(dias / 30);
  let años = Math.floor(meses / 12);
  let horasRestantes = horas % 24;
  let minutosRestantes = minutos % 60;
  let segundosRestantes = segundos % 60;
  let diasRestantes = dias % 30;
  let mesesRestantes = meses % 12;
  let añosRestantes = años;
  return `${horasRestantes}h ${minutosRestantes}m ${segundosRestantes}s`;
}

export function CaracteresMinimos(cantidad: number) {
  return "Debe contener almenos " + cantidad + " caracteres";
}
export function CaracteresMaximos(cantidad: number) {
  return "Debe contener menos de " + cantidad + " caracteres";
}

export function CampoRequerido(nombrecampo: string) {
  return nombrecampo + " es requerido";
}

export const Paises = [
  { label: "🇦🇷 Argentina", value: "Argentina" },
  { label: "🇦🇺 Australia", value: "Australia" },
  { label: "🇧🇷 Brasil", value: "Brasil" },
  { label: "🇨🇦 Canada", value: "Canada" },
  { label: "🇨🇱 Chile", value: "Chile" },
  { label: "🇨🇴 Colombia", value: "Colombia" },
  { label: "🇪🇸 España", value: "España" },
  { label: "🇺🇸 Estados Unidos", value: "Estados Unidos" },
  { label: "🇬🇧 Gran Bretaña", value: "Gran Bretaña" },
  { label: "🇮🇹 Italia", value: "Italia" },
  { label: "🇲🇽 Mexico", value: "Mexico" },
  { label: "🇵🇪 Peru", value: "Peru" },
  { label: "🇵🇾 Paraguay", value: "Paraguay" },
  { label: "🇻🇪 Venezuela", value: "Venezuela" },
  { label: "🇺🇾 Uruguay", value: "Uruguay" },
  { label: "🇪🇨 Ecuador", value: "Ecuador" },
  { label: "🇵🇹 Portugal", value: "Portugal" },
  { label: "🇳🇱 Holanda", value: "Holanda" },
  { label: "🇩🇪 Alemania", value: "Alemania" },
  { label: "🇫🇷 Francia", value: "Francia" },
  { label: "🇮🇳 India", value: "India" },
  { label: "🇯🇵 Japon", value: "Japon" },
  { label: "🇰🇷 Corea del Sur", value: "Corea del Sur" },
  { label: "🇹🇼 Taiwan", value: "Taiwan" },
  { label: "🇹🇭 Tailandia", value: "Tailandia" },
  { label: "🇨🇳 China", value: "China" },
  { label: "🇷🇺 Rusia", value: "Rusia" },
  { label: "🇸🇪 Suecia", value: "Suecia" },
  { label: "🇳🇴 Noruega", value: "Noruega" },
  { label: "🇩🇰 Dinamarca", value: "Dinamarca" },
  { label: "🇮🇸 Islandia", value: "Islandia" },
  { label: "🇦🇹 Austria", value: "Austria" },
  { label: "🇧🇪 Belgica", value: "Belgica" },
  { label: "🇨🇿 Republica Checa", value: "Republica Checa" },
  { label: "🇭🇺 Hungría", value: "Hungría" },
  { label: "🇮🇪 Irlanda", value: "Irlanda" },
  { label: "🇱🇻 Letonia", value: "Letonia" },
  { label: "🇱🇹 Lituania", value: "Lituania" },
  { label: "🇲🇹 Malta", value: "Malta" },
  { label: "🇵🇱 Polonia", value: "Polonia" },
  { label: "🇷🇴 Rumania", value: "Rumania" },
];
export const getFlag = (country: string) => {
  const type = new Map([
    ["CL", "🇨🇱"],
    ["USA", "🇺🇸"],
    ["BR", "🇧🇷"],
    ["FR", "🇫🇷"],
    ["MX", "🇲🇽"],
    ["EC", "🇪🇨"],
    ["ARG", "🇦🇷"],
    ["UR", "🇺🇾"],
    ["CA", "🇨🇦"],
    ["PY", "🇵🇾"],
    ["PE", "🇵🇪"],
    ["ES", "🇪🇸"],
    ["EN", "🇬🇧"],
  ]);

  return type.get(country.toLowerCase().toUpperCase());
};
export const getFlagByCountryId = (countryId: number): string | undefined => {
  const flags = new Map<number, string>([
    [1, "🇨🇱"], [2, "🇦🇷"], [3, "🇦🇺"], [4, "🇧🇷"], [5, "🇨🇦"],
    [7, "🇨🇴"], [8, "🇪🇸"], [9, "🇺🇸"], [10, "🇬🇧"], [11, "🇮🇹"],
    [12, "🇲🇽"], [13, "🇵🇪"], [14, "🇵🇾"], [15, "🇻🇪"], [16, "🇺🇾"],
    [17, "🇪🇨"], [18, "🇵🇹"], [19, "🇳🇱"], [20, "🇩🇪"], [21, "🇫🇷"],
    [22, "🇮🇳"], [23, "🇯🇵"], [24, "🇰🇷"], [25, "🇹🇼"], [26, "🇹🇭"],
    [27, "🇨🇳"], [28, "🇷🇺"], [29, "🇸🇪"], [30, "🇳🇴"], [31, "🇩🇰"],
    [32, "🇮🇸"], [33, "🇦🇹"], [34, "🇧🇪"], [35, "🇨🇿"], [36, "🇭🇺"],
    [37, "🇮🇪"], [38, "🇱🇻"], [39, "🇱🇹"], [40, "🇲🇹"], [41, "🇵🇱"],
    [42, "🇷🇴"],
  ]);

  return flags.get(countryId);
};

//filtro banner TOPHOME
export const filterAdsImgHome = (data: Array<any>, currentLanguage: string) => {
  let sponsorWithImages = data.filter(
    (item) =>
      item.image_carruseltop_path !== null &&
      item.countDownImages !== "" &&
      item.buycarrusel_top === true &&
      item.status === "IN_PROGRESS" &&
      item.isactive === true &&
      item.language === currentLanguage
  );
  if (sponsorWithImages.length === 0) {
    sponsorWithImages = data.filter(
      (item) =>
        item.image_carruseltop_path !== null &&
        item.countDownImages !== "" &&
        item.buycarrusel_top === true &&
        item.status === "IN_PROGRESS" &&
        item.isactive === true &&
        item.language === "en"
    );
  }
  // console.log('Que trae esté elemento?',sponsorWithImages);
  const imagesTop = sponsorWithImages.map((item: any, index: number) => {
    // console.log("Que trae item?",item)
    const name = item.sponsor_name || "";
    const url = item.sponsor_url || "";
    const timeShow = item.countDownImage?.[index] || 5000;
    const image = item.image_carruseltop_path || "";
    return {
      name,
      url,
      timeShow,
      image,
    };
  });
  return imagesTop;
};

//Filter banner bottomVideos
export const filterAdsImgBvideos = (
  data: Array<any>,
  currentLanguage: string
) => {
  let sponsorWithImages = data.filter(
    (item) =>
      item.image_carruselvideo_path !== null &&
      item.countDownImages !== "" &&
      item.buycarrusel_videos === true &&
      item.status === "IN_PROGRESS" &&
      item.isactive === true &&
      item.language === currentLanguage
  );
  if (sponsorWithImages.length === 0) {
    sponsorWithImages = data.filter(
      (item) =>
        item.image_carruselvideo_path !== null &&
        item.countDownImages !== "" &&
        item.buycarrusel_videos === true &&
        item.status === "IN_PROGRESS" &&
        item.isactive === true &&
        item.language === "en"
    );
  }
  // console.log('Que trae?',sponsorWithImages)
  const imgBottomVideo = sponsorWithImages.map((item: any, index: number) => {
    const name = item.sponsor_name || "";
    const url = item.sponsor_url || "#";
    const timeShow = item.countDownImages?.[0] || 5000;
    const image = item.image_carruselvideos_path || "";

    return {
      name,
      url,
      timeShow,
      image,
    };
  });
  return imgBottomVideo;
};
//Filter banner BTW VIDEOS
export const filterAdsBtwVideos = (
  data: Array<any>,
  currentLanguage: string
) => {
  let sponsorWithImages = data.filter(
    (item) =>
      item.image_btw_videos_path?.length > 0 &&
      item.buy_btwVideos === true &&
      item.status === "IN_PROGRESS" &&
      item.isactive === true &&
      item.language === currentLanguage
  );

  // Si no hay imágenes para el idioma actual, filtrar por inglés
  if (sponsorWithImages.length === 0) {
    sponsorWithImages = data.filter(
      (item) =>
        item.image_btw_videos_path?.length > 0 &&
        item.buy_btwVideos === true &&
        item.status === "IN_PROGRESS" &&
        item.isactive === true &&
        item.language === "en"
    );
  }

  const imagesArray = sponsorWithImages.reduce((accumulator, item) => {
    const name = item.sponsor_name || "";
    const url = item.sponsor_url || "#";
    const timeShow = item.countDownImages?.[0] || 5000;
    const images = item.image_btw_videos_path || [];

    return [
      ...accumulator,
      ...images.map((image) => ({
        name,
        url,
        timeShow,
        image,
      })),
    ];
  }, []);
  return imagesArray;
};
//Filter ads Videos
export const filterAdsVideos = (data: Array<any>, currentLanguage: string) => {
  let sponsorWithVideos: any = data.filter(
    (item) =>
      item.videos_adspath !== "" &&
      item.buyvideo_ads !== false &&
      item.status === "ACTIVE" &&
      item.status === "IN_PROGRESS" &&
      item.language === currentLanguage
  );
  //Si no hay videos para el idioma actual , filtrar por ingles.
  if (sponsorWithVideos.length === 0) {
    sponsorWithVideos = data.filter(
      (item: any) =>
        item.videos_adspath !== "" &&
        item.buyvideo_ads !== false &&
        item.status === "IN_PROGRESS" &&
        item.language === "en"
    );
  }

  //Procesar los paths de los videos
  const videosAdsArr = sponsorWithVideos
    .flatMap((item) => {
      if (typeof item.videos_adspath === "string") {
        return item.videos_adspath.split(",");
      } else if (Array.isArray(item.videos_adspath)) {
        return [].concat(...item.videos_adspath);
      }
      return [];
    })
    .map((src) => ({ src }));

  return videosAdsArr;
};

export const formatterAmount = (
  amount: number = 0,
  currency: string = "CLP",
  language: string = "es-CL"
) => {
  const value = new Intl.NumberFormat(language, {
    style: "currency",
    currency,
  }).format(amount);
  return value;
};

export async function getCountryInfo() {
  if (!navigator.geolocation) {
    throw new Error("Geolocalización no es compatible con este navegador.");
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;

          // Usar una API de geocoding (ejemplo: Nominatim)
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          if (!response.ok) throw new Error("Error en la API de Nominatim.");
          const data = await response.json();

          // Obtener el código del país
          const countryCode = data.address.country_code.toUpperCase();

          // Usar REST Countries para obtener más detalles
          const countryResponse = await fetch(
            `https://restcountries.com/v3.1/alpha/${countryCode}`
          );
          if (!countryResponse.ok)
            throw new Error("Error en la API de REST Countries.");
          const countryData = await countryResponse.json();

          resolve({
            country: countryData[0].name.common,
            language: Object.values(countryData[0].languages).join(", "),
            currency: Object.keys(countryData[0].currencies).join(", "),
          });
        } catch (error) {
          reject(`Error procesando la información: ${error.message}`);
        }
      },
      (error) => {
        reject(`Error obteniendo la ubicación: ${error.message}`);
      }
    );
  });
}

export const formatLanguague = (country: string): TOptions["locale"] => {
  const languagueMap: Record<string, TOptions["locale"]> = {
    Argentina: "es-AR",
    Chile: "es-CL",
    Colombia: "es-CO",
    México: "es-MX",
    Venezuela: "es-VE",
    Uruguay: "es-UY",
    Perú: "es-PE",
    Brasil: "pt-BR",
    Usa: "en-US",
  };
  return languagueMap[country] || "es-CL"; // Valor por defecto
};

export const convertTypeFrequency = (frequency: string) => {
  if (frequency === "monthly") {
    return "mensual";
  }
  return "anual";
};
